// import { getAllTokens } from '@dyl/apiClients/backendApi';
import { selectedTokensData } from '@dyl/apiClients/backendApi';
import { useCallback } from 'react';
import useTokensDownload from '../useTokensDownload';

export default function useExport() {
    const download = useTokensDownload();

    return useCallback(
        /**
         * @param {string[]} selectedIds
         */
        async function ExportTokens(selectedIds) { //level_id, filterParams = {}
            console.log("Selected Tokens :", selectedIds);
            let tokensToExport = {};

            // if(selectedIds.length === 0){
            //     tokensToExport = await getAllTokens(level_id, filterParams);
            // } else
            if (selectedIds.length > 0) {
                tokensToExport = await selectedTokensData(selectedIds);
            }

            console.log("Token Data :", JSON.stringify(tokensToExport));

            const toExport = tokensToExport.tokens;

            // const toExport = (
            //     selectedIds.length === 0 ? allTokens
            //     : allTokens.filter(t => selectedIds.includes(t.token_id))
            // );

            await download(toExport);

        }, [download]
    );
}